import { Component, OnInit, Input } from '@angular/core';
import { Constants } from 'app/utility/constants';

@Component({
    selector: 'app-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    standalone: false
})
export class SkeletonComponent implements OnInit
{

	@Input() type: 'result-noavatar' | 'result' | 'list' | 'summary' | 'result-column' | 'result-sublist' | 'details' | 'summary-2025' | 'images';
	@Input() cols: number;

	constructor() { }

	public calculatedImageHeight: number;
	public isMobile: boolean = false;
	ngOnInit()
	{
		this.isMobile = window.innerWidth < 768;
		
		this.calculatedImageHeight = (Math.round(window.innerWidth * 0.75));

		if (this.calculatedImageHeight < 75)
		{
			this.calculatedImageHeight = 75;
		}
		if (this.calculatedImageHeight > 400)
		{
			this.calculatedImageHeight = 400;
		}

		if (!cols)
		{
			var resultLayout = localStorage.getItem(Constants.LocalStorage_ResultLayout);

			var cols = 12;
			if (resultLayout == "grid")
			{
				if (window.innerWidth > 5000)
				{
					cols = 1;
				}
				else if (window.innerWidth > 3000)
				{
					cols = 2;
				}
				else if (window.innerWidth > 2280)
				{
					cols = 3;
				}
				else if (window.innerWidth > 1300)
				{
					cols = 4;
				}
				else if (window.innerWidth > 767)
				{
					cols = 6;
				}
			}
			this.cols = cols;
		}

		
	}

}
